import { inject, Injectable, signal } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { OrganizationService } from "@main/companies";
import { CurrentUserChangedData, UserService } from "@main/users";
import { UserHelperService } from "@main/users/user-helper.service";

@Injectable()
export class BrandingService {
    private readonly organizationService = inject(OrganizationService);
    private readonly userHelperService = inject(UserHelperService);
    private readonly broadcastService = inject(BroadcastService);

    private _showMiProBranding = signal<boolean>(false);
    private _currentOrganizationLogoUrl = signal<string>(null);
    
    readonly showMiProBranding = this._showMiProBranding.asReadonly();
    readonly currentOrganizationLogoUrl = this._currentOrganizationLogoUrl.asReadonly();

    constructor() {
        this.broadcastService.on<CurrentUserChangedData>(UserService.CurrentUserChangedEventName)
            .subscribe(() => this.refreshLogos());
        this.broadcastService.on(OrganizationService.OrganizationChangedEventName)
            .subscribe(() => this.refreshLogos());

        this.refreshLogos();
    }

    async refreshLogos() {
        const info = await this.organizationService.getCurrentSelfRegistrationInfo();
        this._showMiProBranding.set(info.showMiProBranding);
        this._currentOrganizationLogoUrl.set(info.logoImage?.url);
    }

}